module.exports = __webpack_public_path__ + "img/Crowdfunding_Lady_512x512.34362174.png";